import React from "react";
import * as echarts from "echarts";

class SparkleCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updateData: [...props.mainData],
    };
  }

  componentDidMount() {
    this.chartPlace();
  }

  chartPlace = () => {
    const { chartColor, index } = this.props;
    const chartDom = document.getElementById("main" + index);
    const myChart = echarts.init(chartDom);

    const option = {
      tooltip: {
        trigger: "axis",
        formatter: function (value) {
          return value[0].data;
        },
      },
      grid: {
        left: 0,
        bottom: 0,
        top: 5,
        right: 0,
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          axisLine: {
            show: false,
          },
          animation: {
            duration: 300,
            easing: "cubicOut",
          },
          data: [0, 1, 2, 3, 4, 5],
        },
      ],
      yAxis: [
        {
          type: "value",
          splitLine: { show: false },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          data: [0, 2, 4, 6, 8, 10],
        },
      ],
      series: [
        {
          type: "line",
          data: this.state.updateData,
          areaStyle: {
            color: chartColor ? chartColor : "#f79647",
          },
          itemStyle: {
            color: chartColor ? chartColor : "#f79647",
          },
          symbolSize: 1,
        },
      ],
    };

    option && myChart.setOption(option);
  };

  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }

  render() {
    const { Heading, Money, PerText, ContainerClass, index, variant } = this.props;
    const isDashboardCard = variant === "dashboard";
    const icons = ["fa-try", "fa-wrench", "fa-file-text-o", "fa-users"];
    const percentValue = parseFloat(PerText);
    const directionClass = Number.isNaN(percentValue) || percentValue === 0
      ? "neutral"
      : percentValue > 0 ? "positive" : "negative";
    return (
        <div className={ContainerClass}>
          <div className={`card overflowhidden number-chart${isDashboardCard ? ` dz-kpi-card tone-${index % 4}` : ""}`}>
            <div className={`body${isDashboardCard ? " dz-kpi-body" : ""}`}>
              {isDashboardCard && (
                <div className="dz-kpi-top">
                  <span className="dz-kpi-icon"><i className={`fa ${icons[index % icons.length]}`} /></span>
                  <span className={`dz-kpi-change ${directionClass}`}>
                    <i className={`fa ${directionClass === "negative" ? "fa-arrow-down" : directionClass === "positive" ? "fa-arrow-up" : "fa-minus"}`} />
                    {PerText}
                  </span>
                </div>
              )}
              <div className={`number${isDashboardCard ? " dz-kpi-value" : ""}`}>
                <h6>{Heading}</h6>
                <span>{Money}</span>
              </div>
              {!isDashboardCard && <small className="text-muted">{PerText}</small>}
            </div>
            <div
                id={"main" + index}
                className={`sparkline${isDashboardCard ? " dz-kpi-sparkline" : ""}`}
                style={{ width: "100%", height: 55 }}
            ></div>
          </div>
        </div>
    );
  }
}

export default SparkleCard;
